import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { NavDropdown, Navbar, Nav, NavLink } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import AuthActions from '../../store/modules/auth/actions';
import userStore from '../../store';
import api from '../../services/rewardsApi';
import establishmentStore from '../../store/establishment';

import routes from '../../routes/routes';

import * as Styled from './styles';
import DropdownItem from 'react-bootstrap/esm/DropdownItem';

export default function Menu() {
  const state = userStore.getState();
  const path = useSelector(store => store.path);
  const history = useHistory();
  const dispatch = useDispatch();
  const user = state.auth?.user?.properties;

  const [establishments, setEstablishments] = useState([]);
  const currentEstablishment = establishmentStore(
    _state => _state.establishment
  );
  const setCurrentEstablishmentStore = establishmentStore(
    _state => _state.setEstablishment
  );

  function signOut() {
    dispatch(AuthActions.signOut(history));
  }

  useEffect(() => {
    async function fetchEstablishment() {
      const { data } = await api.get(`establishments/${user.id}`);
      if (data.length > 0) {
        setEstablishments(data);
        setCurrentEstablishmentStore(data[0]);
      }
    }
    if (user) fetchEstablishment();
  }, []);

  return (
    <Styled.Navbar sticky="top" collapseOnSelect expand="lg">
      <Navbar.Brand href="/" className="mr-5">
        <img
          src="/images/logo-white.svg"
          alt="logo escrito Cargon"
          width="85px"
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav" className="nav-header">
        <Nav className="mr-auto">
          {routes
            .filter(({ hidden }) => !hidden)
            .map(link => {
              if (link.children) {
                const active = link.children.find(item => {
                  return item.path === path;
                });

                return (
                  <Styled.NavDropdown
                    active={active}
                    title={link.title}
                    id={link.path}
                  >
                    {link.children
                      .filter(({ hidden }) => !hidden)
                      .sort((a, b) => {
                        let order;
                        // eslint-disable-next-line no-unused-expressions
                        a.title > b.title
                          ? (order = 1)
                          : a.title < b.title
                          ? (order = -1)
                          : (order = 0);
                        return order;
                      })
                      .map(item => (
                        <NavDropdown.Item
                          to={item.path}
                          as={Link}
                          key={item.path}
                        >
                          <span>{item.title}</span>
                        </NavDropdown.Item>
                      ))}
                  </Styled.NavDropdown>
                );
              }
              const active = path && path === link.path;
              return (
                <Styled.NavLink
                  as={Link}
                  to={link.path}
                  key={link.path}
                  active={active}
                >
                  {link.title}
                </Styled.NavLink>
              );
            })}
        </Nav>
        <Nav variant="pills" className="justify-content-end">
          {establishments.length === 1 ? (
            <Navbar.Text
              style={{
                color: 'white',
                fontSize: '13px',
                borderRadius: '5px',
                marginRight: '15px',
              }}
            >
              {establishments[0].social_name} - {establishments[0].cgccpf}
            </Navbar.Text>
          ) : (
            <Styled.NavDropdown
              title={
                currentEstablishment
                  ? `Estabelecimento: ${currentEstablishment.social_name} (${currentEstablishment.cgccpf})`
                  : 'Nenhum estabelecimento selecionado'
              }
            >
              {establishments.map(establishment => {
                if (currentEstablishment?.id !== establishment.id) {
                  return (
                    <DropdownItem
                      onClick={() =>
                        setCurrentEstablishmentStore(establishment)
                      }
                    >
                      {establishment.social_name} ({establishment.cgccpf})
                    </DropdownItem>
                  );
                }
                return <></>;
              })}
            </Styled.NavDropdown>
          )}
          <Nav.Item>
            <NavLink
              as={Link}
              onClick={() => signOut()}
              to="#"
              className="text-uppercase"
            >
              Sair
            </NavLink>
          </Nav.Item>
        </Nav>
      </Navbar.Collapse>
    </Styled.Navbar>
  );
}
